module.exports = __webpack_public_path__ + "static/bci-logo-4ed7bd9d0b34f8e1928f97f5e93e9a09.png";